import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginSmsPageComponent } from './containers/login-sms-page.component';
import { LoginEmailPageComponent } from './containers/login-email-page.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { LoginEmailComponent } from './components/login-email/login-email.component';
import { LoginSmsComponent } from './components/login-sms/login-sms.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { LoginEffects } from './effects/login.effects';
import { reducers } from './reducers';
import { LoginNavComponent } from './components/login-nav/login-nav.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    StoreModule.forFeature('login', reducers),
    EffectsModule.forFeature([LoginEffects]),
  ],
  declarations: [LoginSmsPageComponent, LoginEmailPageComponent, LoginEmailComponent, LoginSmsComponent, LoginNavComponent],
  exports: [LoginSmsPageComponent, LoginEmailPageComponent, LoginEmailComponent, LoginSmsComponent],
})
export class LoginModule { }



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/login.module.ts